import { IStore } from 'redux/IStore';
import * as React from 'react';
import { Helmet } from 'react-helmet';
import * as serialize from 'serialize-javascript';
const config = require('../../../../config/main');

interface IHtmlProps {
	manifest?: any;
	markup?: string;
	store?: Redux.Store<IStore>;
	cacheVersion?: string;
}

class Html extends React.Component<IHtmlProps, {}> {
	private resolve(files) {
		return files.map((src) => this.props.manifest[src]).filter(Boolean);
	}

	private prependVersion(src: string) {
		return src + '?v=' + (this.props.cacheVersion || '0');
	}

	public render() {
		const head = Helmet.rewind();
		const { markup, store } = this.props;

		const styles = this.resolve(['vendor.css', 'app.css']);
		const renderStyles = styles.map((src, i) => (
			<link key={i} rel="stylesheet" type="text/css" href={this.prependVersion(src)} />
		));

		const scripts = this.resolve(['vendor.js', 'app.js']);
		const renderScripts = scripts.map((src, i) => <script src={this.prependVersion(src)} key={i + '_script'} />);
		renderScripts.unshift(
			<script
				key="google_places_script"
				type="text/javascript"
				src={`https://maps.googleapis.com/maps/api/js?key=${config.app.googleSettings.mapsApi}&loading=async&callback=Function.prototype&libraries=places,marker`}
			/>,
		);
		renderScripts.unshift(
			<script key="stripe_payment_script" type="text/javascript" src="https://js.stripe.com/v3/" />,
		);

		//tslint:disable-next-line:max-line-length
		const initialState = (
			<script
				dangerouslySetInnerHTML={{
					__html: `window.__INITIAL_STATE__=${serialize(store.getState(), { isJSON: true })};`,
				}}
			/>
		);

		const loaderHolder = (
			<div className="loaderHolder">
				<img src={require('containers/Html/images/logo/glossiq_preloader.svg')} />
			</div>
		);

		return (
			<html translate="no">
				<head>
					{head.base.toComponent()}
					{head.title.toComponent()}
					{head.meta.toComponent()}
					{head.link.toComponent()}
					{head.script.toComponent()}

					{/* Google ads */}
					<script
						async
						src={`https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${config.app.googleSettings.adclient}`}
						crossOrigin="anonymous"
					/>

					<style
						dangerouslySetInnerHTML={{
							__html: `
            body {
              overflow-y: hidden;
            }
            .preloaderBody {
              background-color: black;
              position: fixed;
              left: 0;
              top: 0;
              width: 100%;
              height: 100vh;
              display: block;
              z-index: 99999;
              transform-origin: center center;
              transition: all 0.5s ease-out;
              transition-delay: 2.5s;
            }
            .loaderHolder {
              position: absolute;
              top: 50%;
              left: 50%;
              transform-origin: center center;
              transform: translate(-50%, -50%);
            }
            .preloaderBody img {
              width: 14vw;
              height: 6vw;
            }
            .preloaderBody.transition {
              opacity: 0;
            }
            @media (max-width: 990px) {
              .preloaderBody img {
                width: 20vw;
                height: 8vw;
              }
            }
            @media (max-width: 760px) {
              .preloaderBody img {
                width: 30vw;
                height: 10vw;
              }
            }
            @media (max-width: 480px) {
              .preloaderBody img {
                width: 40vw;
                height: 14vw;
              }
            }
            `,
						}}
					/>

					{renderStyles}

					<link rel="apple-touch-icon" sizes="180x180" href="/public/apple-touch-icon.png" />
					<link rel="icon" type="image/png" sizes="32x32" href="/public/favicon-32x32.png" />
					<link rel="icon" type="image/png" sizes="16x16" href="/public/favicon-16x16.png" />
					<link rel="manifest" href="/public/site.webmanifest" />
					<link rel="mask-icon" href="/public/favicon-32x32.png" color="#bdff3b" />
					<meta name="msapplication-TileColor" content="#da532c" />
					<meta name="theme-color" content="#121212" />
					<meta charSet="utf-8" />
				</head>
				<body>
					<div className="preloaderBody" id="preloader">
						{loaderHolder}
					</div>
					<div id="app" dangerouslySetInnerHTML={{ __html: markup }} />
					{initialState}
					{renderScripts}
				</body>
			</html>
		);
	}
}

export { Html };
